import Vue from "vue";
import VueRouter from "vue-router";
import {redirectLogin} from "@/network/sso";
import Login from "@/views/Login";
import VueCookies from "vue-cookies";
import bigHome from '@/views/bigScreen/home'

Vue.use(VueRouter);

const routes = [
  {
    name: "登录中...",
    path: "/login",
    component: Login,
    meta: {requiresAuth: false}
  },
  {
    name: "大屏",
    path: "/",
    redirect: 'home',
    component: bigHome,
    meta: {requiresAuth: true},
    children: [
      {
        path: 'home', // 路由显示的地址
        name: '首页', // 路由的名字，必须填写且唯一
        meta: { title: '河南省5G能源路由器综合管理平台', requiresAuth: true }, // 侧边栏文字和icon
        component: () => import('@/views/bigScreen/index/index') // 实际页面地址
      },
    ]
  },
  {
    name: "首页",
    path: "/platen",
    redirect: '/platen',
    component: () => import('../views/Index'),
    meta: {requiresAuth: true},
    children: [
      {
        name: "综合态势",
        path: "overview",
        component: () => import('../views/overview/Overview'),
        meta: {requiresAuth: true},
      },
      {
        name: "空间概览",
        path: "space-overview",
        component: () => import('../views/space_overview/spaceOverview'),
        meta: {requiresAuth: true},
      },
      {
        name: "节点拓扑",
        path: "system-framework",
        component: () => import('../views/system_framework/systemFramework'),
        meta: {requiresAuth: true},
      },
      {
        name: "综合态势配置",
        path: "/overview-setting",
        component: () => import('../views/overview/ConfigurationListEdit'),
        meta: {requiresAuth: true},
      },
      {
        name: "大屏可视化",
        path: "platen",
        component: () => import('../views/platen/Index'),
        meta: {requiresAuth: true},
      },
      {
        name: "告警中心",
        path: 'realTime-alarm',
        component: () => import('@/views/alarm/RealTimeAlarm'),
        meta: {requiresAuth: true}
      },
      {
        name: "设备一览 ",
        path: 'device-list',
        component: () => import('@/views/basic_operations/monitoring/device_list/DeviceIndex'),
        meta: {requiresAuth: true}
      },
      {
        name: "设备类型全览",
        path: 'deviceType-list',
        component: () => import('@/views/basic_operations/device_management/humiture_device/humiture_device'),
        meta: {requiresAuth: true}
      },
      {
        name: "设备拓扑图",
        path: 'device-topology',
        component: () => import('@/views/basic_operations/topology/TreeDiagram'),
        meta: {requiresAuth: true}
      },
      {
        name: "设备详情 ",
        path: 'device-detail',
        component: () => import('@/views/basic_operations/monitoring/device_details/DeviceDetail'),
        meta: {requiresAuth: true}
      },
      {
        name: "温湿度",
        path: 'temperature-humidity',
        component: () => import('@/views/temperature_humidity/AllSpaceTemperatureHumidity'),
        meta: {requiresAuth: true}
      }
    ],
  },
  {
    name: "楼层导航",
    path: "/floor",
    redirect: '/floor/floor-navigation',
    component: () => import('../views/Index'),
    meta: {requiresAuth: true},
    children: [
      {
        name: "楼层导航",
        path: "floor-navigation",
        component: () => import('@/views/floor_navigation/FloorNavigation'),
        meta: {requiresAuth: true},
      },
    ]
  },
  {
    name: "电力监控系统",
    path: "/electricity",
    component: () => import('../views/Index'),
    meta: {requiresAuth: true},
    children: [
      {
        name: "电力监控系统",
        path: "",
        component: () => import('@/views/configuration_diagram/ConfigurationDiagram'),
        meta: {requiresAuth: true, systemType: 1},
      },
    ]
  },
  {
    name: "BA监控系统",
    path: "/group-control",
    component: () => import('../views/Index'),
    meta: {requiresAuth: true},
    children: [
      {
        name: "BA监控系统",
        path: "",
        component: () => import('@/views/configuration_diagram/ConfigurationDiagram'),
        meta: {requiresAuth: true, systemType: 2  },
      },
    ]
  },
  {
    name: "PTMS",
    path: "/ptms-cabinet",
    component: () => import('../views/Index'),
    meta: {requiresAuth: true},
    children: [
      {
        name: "PTMS",
        path: "",
        component: () => import('@/views/configuration_diagram/ConfigurationDiagram'),
        meta: {requiresAuth: true, systemType: 3},
      },
    ]
  },
  {
    path: "/device-manager",
    redirect: '/device-manager/device-space',
    component: () => import('@/views/basic_operations/BasicOperations1'),
    meta: {requiresAuth: true},
    children: [
      {
        name: "网络拓扑图",
        path: 'network-topology',
        component: () => import('@/views/basic_operations/device_management/network_topology/NetworkTopology'),
        meta: {requiresAuth: true}
      },
      {
        name: "电力接线图",
        path: 'power-wiring-diagram',
        component: () => import('@/views/basic_operations/device_management/power_wiring_diagram/PowerWiringDiagram'),
        meta: {requiresAuth: true}
      },
      {
        name: "设备(空间)",
        path: 'device-space',
        component: () => import('@/views/basic_operations/device_management/device_manager/DeviceManager'),
        meta: {requiresAuth: true}
      },
      {
        name: "电子地图",
        path: 'electronic-map',
        component: () => import('@/views/basic_operations/device_management/electronic_map/Index'),
        meta: {requiresAuth: true}
      },
      {
        name: "主机",
        path: 'gateway-list',
        component: () => import('@/views/basic_operations/device_management/host/Host'),
        meta: {requiresAuth: true}
      },
      {
        name: "区域地图",
        path: 'area-map',
        component: () => import('@/views/basic_operations/device_management/area_map/Index'),
        meta: {requiresAuth: true}
      },
      {
        name: "暖通设备",
        path: 'alternate_device',
        component: () => import('@/views/basic_operations/device_management/alternate_device/alternate_device'),
        meta: {requiresAuth: true}
      },
      {
        name: "机柜管理",
        path: 'cabinet-manage',
        component: () => import('@/views/basic_operations/device_management/cabinetManage/cabinetManage'),
        meta: {requiresAuth: true}
      }
    ]
  },
  {
    path: "/strategy",
    redirect: '/strategy/shield',
    component: () => import('@/views/basic_operations/BasicOperations1'),
    meta: {requiresAuth: true},
    children: [
      {
        name: "告警等级策略",
        path: '/strategy/alarm-level',
        component: () => import('@/views/basic_operations/strategy/alarm_level/AlarmLevel'),
        meta: {requiresAuth: true}
      },
      {
        name: "告警升级策略",
        path: '/strategy/alarm-upgrade',
        component: () => import('@/views/basic_operations/strategy/alarm_upgrade/AlarmUpgrade'),
        meta: {requiresAuth: true}
      },
      {
        name: "告警收敛策略",
        path: '/strategy/alarm_convergence',
        component: () => import('@/views/basic_operations/strategy/alarm_convergence/AlarmConvergence'),
        meta: {requiresAuth: true}
      },
      {
        name: "告警屏蔽策略",
        path: '/strategy/shield',
        component: () => import('@/views/basic_operations/strategy/shield/Shield'),
        meta: {requiresAuth: true}
      },
      {
        name: "误告警策略",
        path: '/strategy/alarm-miss',
        component: () => import('@/views/basic_operations/strategy/alarm_miss/AlarmMiss1'),
        meta: {requiresAuth: true}
      },
      {
        name: "设备权限策略",
        path: '/strategy/authority',
        component: () => import('@/views/basic_operations/strategy/authority/DeviceAuthority'),
        meta: {requiresAuth: true}
      },
      {
        name: "空间权限策略",
        path: '/strategy/spaceAuthority',
        component: () => import('@/views/basic_operations/strategy/space-authority/spaceAuthority'),
        meta: {requiresAuth: true}
      },
      {
        name: "通知接收人策略",
        path: '/strategy/notice-receiver',
        component: () => import('@/views/basic_operations/strategy/notice/NoticeReceiver'),
        meta: {requiresAuth: true}
      },
      {
        name: "设备联动",
        path: '/strategy/linkage/device',
        component: () => import('@/views/basic_operations/strategy/linkage/LinkageList'),
        meta: {requiresAuth: true}
      },
      {
        name: "联动策略编辑",
        path: '/strategy/linkage/device/edit-linkage',
        component: () => import('@/views/basic_operations/strategy/linkage/simple/LinkageEdit'),
        meta: {requiresAuth: true}
      },
      {
        name: "联动记录列表",
        path: '/strategy/linkage/device/linkage-log-list',
        component: () => import('@/views/basic_operations/strategy/linkage/complex/LinkageLogList'),
        meta: {requiresAuth: true}
      },
      {
        name: "流程",
        path: '/strategy/process',
        component: () => import('@/views/basic_operations/strategy/process_engine/process/ProcessList'),
        meta: {requiresAuth: true}
      },
      {
        name: "增/改流程",
        path: '/strategy/process/edit-process',
        component: () => import('@/views/basic_operations/strategy/process_engine/process/EditProcess'),
        meta: {requiresAuth: true}
      },
    ]
  },
  {
    path: "/historical",
    redirect: '/historical/device-history',
    component: () => import('@/views/basic_operations/BasicOperations1'),
    meta: {requiresAuth: true},
    children: [
      {
        name: "历史数据",
        path: '/historical/device-history',
        component: () => import('@/views/basic_operations/monitoring/historical_data/HistoricalData'),
        meta: {requiresAuth: true}
      },
      {
        name: "告警历史",
        path: '/historical/alarm-history',
        component: () => import('@/views/alarm/History'),
        meta: {requiresAuth: true}
      },
      {
        name: "数据曲线",
        path: '/historical/data-curve',
        component: () => import('@/views/basic_operations/monitoring/data-curve/DataCurve'),
        meta: {requiresAuth: true}
      },
      {
        name: "服务器监控",
        path: '/historical/serverUsageDetails',
        component: () => import('@/views/basic_operations/monitoring/server_usage/ServerUsageDetails'),
        meta: {requiresAuth: true}
      }
    ]
  },
  {
    path: "/sys-setting",
    redirect: '/sys-setting/notification',
    component: () => import('@/views/basic_operations/BasicOperations1'),
    meta: {requiresAuth: true},
    children: [
      {
        name: "通知配置",
        path: '/sys-setting/notification',
        component: () => import('@/views/basic_operations/sys_setting/notification_configuration/NotificationConfiguration'),
        meta: {requiresAuth: true}
      },
      {
        name: "阿里云短信模板配置",
        path: '/sys-setting/smsTemplate',
        component: () => import('@/views/basic_operations/sys_setting/sms_template/Template'),
        meta: {requiresAuth: true}
      },
      {
        name: "告警等级配置",
        path: '/sys-setting/alarm-level',
        component: () => import('@/views/basic_operations/sys_setting/alarm_level/AlarmLevel'),
        meta: {requiresAuth: true}
      },
      {
        name: "大屏配置 ",
        path: '/sys-setting/large-size-screen',
        component: () => import('@/views/basic_operations/sys_setting/large_size_screen/LargeSizeScreen'),
        meta: {requiresAuth: true}
      },
      {
        name: "系统联动",
        path: '/sys-setting/linkage',
        component: () => import('@/views/basic_operations/sys_setting/linkage/Linkage'),
        meta: {requiresAuth: true}
      },
      {
        name: "系统参数",
        path: '/sys-setting/system-parameter',
        component: () => import('@/views/basic_operations/sys_setting/system_parameter/SystemParamter'),
        meta: {requiresAuth: true}
      }
    ]
  },
  {
    path: "/audit-log",
    redirect: '/audit-log/sms',
    component: () => import('@/views/basic_operations/BasicOperations1'),
    meta: {requiresAuth: true},
    children: [
      {
        name: "短信日志",
        path: '/audit-log/sms',
        component: () => import('@/views/basic_operations/audit_log/operation_log/sms/SmsOperationLog'),
        meta: {requiresAuth: true}
      },
      {
        name: "系统操作日志",
        path: '/audit-log/user',
        component: () => import('@/views/basic_operations/audit_log/operation_log/user/UserOperationLog'),
        meta: {requiresAuth: true}
      },
      {
        name: "设备操作日志",
        path: '/audit-log/device',
        component: () => import('@/views/basic_operations/audit_log/operation_log/device/DeviceOperationLog'),
        meta: {requiresAuth: true}
      }
    ]
  },
  {
    path: "/basic-operations",
    redirect: '/basic-operations/device-manager',
    component: () => import('@/views/basic_operations/BasicOperations1'),
    meta: {requiresAuth: true},
    children: [
      {
        name: "设备一览",
        path: 'device-list',
        component: () => import('@/views/basic_operations/monitoring/device_list/DeviceList'),
        meta: {requiresAuth: true}
      }, {
        name: "视频监控",
        path: 'video-surveillance',
        component: () => import('@/views/basic_operations/monitoring/video_surveillance/VideoSurveillance'),
        meta: {requiresAuth: true}
      }, {
        name: "设备详情",
        path: 'device-detail',
        component: () => import('@/views/basic_operations/monitoring/device_details/DeviceDetail'),
        meta: {requiresAuth: true}
      },
    ]
  },
  {
    name: "大屏配置",
    path: "/platen-setting",
    component: () => import('@/views/platen/PlatenSetting'),
    meta: {requiresAuth: true},
  },
  {
    name: "编辑网络拓扑图",
    path: '/edit-network-topology',
    component: () => import('@/components/antVx6/index'),
    meta: {requiresAuth: true}
  },
  /*
  * dcimAppH5页面路由
  * */
  {
    name: "动环app设备地图",
    path: "/dcim-device-map",
    component: () => import('@/views/dcim_vue_app/device_map/Overview'),
    meta: {requiresAuth: false}
  }, {
    name: "动环app设备拓扑",
    path: '/dcim-device-TreeDiagram',
    component: () => import('@/views/dcim_vue_app/topology/TreeDiagram'),
    meta: {requiresAuth: false}
  }
]

var router = new VueRouter({
  routes
})

router.beforeEach(((to, from, next) => {
  window.document.title = to.name === null ? 'DCIM' : to.name
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    let token = VueCookies.get('token')
    if (token) {
      next()
    } else {
      // 跳转到登录页
      redirectLogin()
    }
  } else if (to.query.token !== undefined) {
    let expiresIn = 43200;
    if (to.query.expiresIn !== undefined) {
      expiresIn = to.query.expiresIn
    }
    // 使用VueCookies在云服务器上拿不到token，这里使用原生的Dom设置Cookies
    // VueCookies.set('token', to.query.token, expiresIn, '/', window.g.domain)
    document.cookie = "token=" + to.query.token + ";expires=" + expiresIn;
    if (to.query.refreshToken !== undefined) {
      // VueCookies.set('refreshToken', to.query.refreshToken, 60 * 60 * 15, '/', window.g.domain)
      document.cookie = "refreshToken=" + to.query.refreshToken + ";expires=" + 60 * 60 * 15;
    }
    next()
  } else {
    next() // 确保一定要调用 next()
  }
}))

export default router;
